import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, BaseResponse, Presence, 
         PresenceResponse, PresenceTimeResponse } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { PresenzeService} from '../service/presenze.service';
import { UserService} from '../service/user.service';
import { environment } from '../../environments/environment';
import { AppConstants } from '../core/app.constants';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-daily-presence',
  templateUrl: './daily-presence.component.html',
  styleUrls: ['./daily-presence.component.css']
})
export class DailyPresenceComponent extends BaseComponent implements OnInit {

    @Input() targetdate: Date;
    @Input() refresh: Subject<boolean>;
    presenceList: Presence[] = new Array();
    completed: boolean = false;
    workedTimeRounded: string = null;
    workedTimeRoundedValued: string = null;
    showDisclaimer: boolean = false;
    currentPresence: Presence = null;
    buttonLabel: string = "";
    buttonClickable: boolean= false;
    isUserAdmin: boolean = false;

    subscriptionTimer: Subscription;
    
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private presenzeService: PresenzeService,
            private userService: UserService)  
    {
        super(authAccess, router, messageProvider);
    }

  ngOnInit() 
  {
      var userContext: UserContext = this.authAccess.getUserContext();
      if(userContext != null)
      {
          if(this.targetdate == null || typeof(this.targetdate) == 'undefined') {
              this.targetdate = new Date();
          }
          this.load();
          this.refresh.asObservable().subscribe(value => { this.load(); });
          let response: BaseResponse;
          this.userService.isUserAdmin(userContext.srmToken).subscribe(
                  result => {
                      response = result;
                      this.isUserAdmin = response.message == "true";
                  },
                  error => {
                      this.handleError(error);
                  }
              );
      }
      else {
          this.authAccess.invalidate();
      }
  }
  
  
  load()
  {
      var userContext: UserContext = this.authAccess.getUserContext();
      if(userContext != null)
      {
          var response: PresenceResponse;
          this.presenzeService.getPresences(userContext.srmToken, this.targetdate, 0).
          subscribe(
               result => {
                   this.completed = true;
                   response = result;
                   this.presenceList = response.presences;
                   var respTr: PresenceTimeResponse;
                   this.presenzeService.timeworked(userContext.srmToken, this.targetdate, null).
                   subscribe(
                       result => {
                          respTr = result;
                          this.workedTimeRounded = AppConstants.formatDuration(respTr.hours, respTr.minutes);
                          this.workedTimeRoundedValued = AppConstants.formatDuration(respTr.hoursValued, respTr.minutesValued);
                       },
                       error => {
                          this.handleError(error);
                       });
               },
               error => {
                   this.completed = true;
                   this.handleError(error);
               });
          }
  }
  
  
  refreshStima()
  {
      this.load();
  }
  
  openDetail(presence: Presence) {
      this.presenzeService.openPresenceDetail(presence == null ? this.currentPresence : presence);
  }

  openDetailFormAdmin() {
      this.presenzeService.openPresenceDetail(new Presence());
  }
  
  openDisclaimer(presence?: Presence)
  {
      this.buttonClickable = false;
      if (this.subscriptionTimer != null) {
        this.subscriptionTimer.unsubscribe();
      }
      this.currentPresence = new Presence();
      if(presence != null && typeof(presence) != 'undefined') {
          this.currentPresence = presence;
      }
      this.showDisclaimer = true;  
      let timer = Observable.timer(5, 1000);
      let counter: number = environment.PRESENZE_DELAY;
      this.buttonLabel = "Attendi " + counter + " secondi";
      this.subscriptionTimer = timer.subscribe(
              t => {
                  this.buttonLabel = "Attendi " + counter + " secondi";
                  --counter;
                  if(counter == -1) {
                      this.buttonLabel = "Sono Consapevole"; 
                      this.buttonClickable = true;
                      this.subscriptionTimer.unsubscribe();
                      this.subscriptionTimer = null;
                  }
              });
  }

  closeDisclaimer() {
      this.showDisclaimer = false;   
      this.buttonClickable = false;
      this.buttonLabel = "";
      if (this.subscriptionTimer != null) {
        this.subscriptionTimer.unsubscribe();
        this.subscriptionTimer = null;
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/daily-presence/daily-presence.component.ts